import { AutogenModelFscCycle, AutogenRowFscCycle } from "./autogen/AutogenModelFscCycle";

export class ModelFscCycle extends AutogenModelFscCycle<RowFscCycle> {
	constructor() {
		super(RowFscCycle);
	}
}

export class RowFscCycle extends AutogenRowFscCycle {
}